import PropTypes from 'prop-types'
import { Stack, ToggleButton, ToggleButtonGroup } from '@mui/material'
import { DateRangeField } from 'src/components/molecules/date-range-field'

/** 期間プリセット。value は「本日を含む遡り日数」 */
export const RANGE_PRESETS = [
  { value: 7, label: '7日' },
  { value: 30, label: '30日' },
  { value: 90, label: '90日' },
  { value: 365, label: '1年' },
]

/** カスタム範囲を表すトグル値（プリセットの日数と衝突しない文字列にする） */
export const CUSTOM_RANGE = 'custom'

/**
 * ダッシュボードの期間セレクタ。プリセット4つ + カスタム範囲（カレンダー）。
 *
 * value はプリセット選択中は日数（number）、カスタム中は CUSTOM_RANGE。
 * カスタム時のみ from / to の DatePicker を表示し、onCustomChange で親へ Date を渡す。
 */
export const PatternRangeSelector = (props) => {
  const { value, onChange, customFrom, customTo, onCustomChange } = props

  const isCustom = value === CUSTOM_RANGE

  return (
    <Stack alignItems={{ xs: 'flex-start', md: 'center' }} direction={{ xs: 'column', md: 'row' }} spacing={2}>
      <ToggleButtonGroup
        color="primary"
        exclusive
        size="small"
        value={value}
        // null は「選択中のボタンを再度押して解除」した場合。期間なしは成立しないので無視する
        onChange={(_, next) => next !== null && onChange(next)}
      >
        {RANGE_PRESETS.map((preset) => (
          <ToggleButton key={preset.value} value={preset.value}>
            {preset.label}
          </ToggleButton>
        ))}
        <ToggleButton value={CUSTOM_RANGE}>カスタム</ToggleButton>
      </ToggleButtonGroup>

      {isCustom && (
        <DateRangeField
          start={customFrom}
          end={customTo}
          maxDate={new Date()}
          onChange={onCustomChange}
        />
      )}
    </Stack>
  )
}

PatternRangeSelector.propTypes = {
  customFrom: PropTypes.instanceOf(Date),
  customTo: PropTypes.instanceOf(Date),
  onChange: PropTypes.func.isRequired,
  onCustomChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
}
